import { FTProcess } from '@/models/FTProcess';
import { initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { ConversionDetails } from '@/models/ConversionDetails';
import _ from 'lodash';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: '',
          goodsFilter: {
            type: ['MRM'], 
            family: ['Board']
          },
          multiple: false,
          params: [
            {
              name: 'Shape',
              type: 'label',
              value: 'Oval',
              disabled: true
            },
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            },
            {
              name: 'Length',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.length', ''),
              unit: 'mm',
              disabled: true
            },
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Width',
          type: 'dimension',
          value: 'width',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'Length',
          type: 'dimension',
          value: 'length',
          unit: 'mm',
          disabled: false
        },{
          name: 'Depth',
          type: 'dimension',
          value: 'depth',
          unit: 'mm',
          disabled: false
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Piece(s) per stroke',
        value: 'pcsPerStroke'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'No of Pieces',
        value: 'numberOfPieces'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  const processInputRow = process.inputs[0];
  const outputFTProcessRow = process.outputs[0];

  conversionResult.outputs[0] = outputFTProcessRow;
  outputFTProcessRow.goodsObject.copyFrom(processInputRow.goodsObject);

  conversionResult.details.numberOfPieces = outputFTProcessRow.goodsObject.perKgRatio.plA.value * processInputRow.quantity;
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = processInputRow.quantity;
  if (process.machineDetail.pcsPerStroke) {
      conversionResult.details.kgPerHour = 60 * outputFTProcessRow.goodsObject.unitWeight * process.machineDetail.mechanicalSpeed * process.machineDetail.pcsPerStroke;
      conversionResult.details.plannedHours = (conversionResult.details.numberOfPieces * outputFTProcessRow.goodsObject.unitWeight) / conversionResult.details.kgPerHour;
  }
  conversionResult.details.pcsPerStroke = process.machineDetail.pcsPerStroke;

  return conversionResult;
}